import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getTestByCourse,
  getTestResult,
  setTestInfo,
} from "../../redux/test/actions";
import { useNavigate, useParams } from "react-router-dom";

export const useTest = () => {
  const [isAlreadySummited, setIsAlreadySubmitted] = useState(false);
  const testInfo = useSelector((state) => state.test.testInfo);
  const testResult = useSelector((state) => state.test.testResult.data);
  const user = useSelector((state) => state.auth.user.data);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id, parent } = useParams();

  const loadingData = new Array(30).fill(1);

  const handleCard = (data) => {
    if (data?.Type) {
      navigate(`/test/${id}/${data.objectId}`);
      return;
    } else {
      const payload = {
        testPtr: data.objectId,
        customerPtr: user.objectId,
      };
      dispatch(setTestInfo(data));
      dispatch(getTestResult(payload));
    }
  };

  const fetchCoure = (skip, limit, isMerge, isNew) => {
    if (id && !parent) {
      let payload = {
        // skipRecord: skip,
        // limit: limit,
        coursePtr: id,
        isMerge,
        isNew,
      };
      dispatch(getTestByCourse(payload));
    } else if (id && parent) {
      let payload = {
        coursePtr: id,
        parentPtr: parent,
        isMerge,
        isNew,
      };
      dispatch(getTestByCourse(payload));
    }
  };

  useEffect(() => {
    if (id && !parent) {
      fetchCoure(0, 30, false, true);
    } else if (id && parent) {
      fetchCoure(0, 30, false, true);
    }
  }, [id, parent]);

  useEffect(() => {
    if (testResult?.status) {
      setIsAlreadySubmitted(true);
    } else if (testResult?.status === false) {
      setIsAlreadySubmitted(false);
      navigate(`/test-info/${id}`);
    }
  }, [testResult]);

  return { testInfo, loadingData, testResult, isAlreadySummited, handleCard };
};
